module.exports = __webpack_public_path__ + "static/hero-cbca6dd9646340bf73b666c943fd352c.jpg";